<template>
  <div class="">
    <b-overlay :show="loading">

        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Manual Assignment
                    <span class="title-sub-text">
                        Manually change
                        <template v-if="roster == 1">shift</template>
                        <template v-else>office time</template>
                        to selected employees within a selected date range.
                    </span>
                </span>
                <span class="float-right"></span>
            </h4>
        </div>
          <div class="row mt-4 px-3 py-4">
        <div class="col-12">

          <b-alert show v-for="error in errors" :key="error">{{ error }}</b-alert>

          <b-form @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-12">

                <div class="row">
                  <div class="col">
                    <b-form-group :label="roster == 1 ? 'Select Shift' : 'Select Office Time'" label-for="shift_id" class="w-100 my-0 required-field">
                      <b-input-group>
                        <b-form-select id="shift_id" name="shift_id" v-model="fdata.shift_id" :options="shifts" v-validate="'required'" data-vv-as="Shift"
                           class="w-100" aria-describedby="shift_id-feedback">
                          <template #first>
                            <b-form-select-option disabled :value="0">
                              <template v-if="roster == 1">
                                Select Shift
                              </template>
                              <template v-else>
                                Select Office Time
                              </template>
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-input-group>
                      <b-form-invalid-feedback id="shift_id-feedback" v-if="veeErrors.has('shift_id')">
                        {{ veeErrors.first('shift_id') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group id="start_date-group" label="Start Date" label-for="start_date" class="required-field mb-0">
                      <b-input-group class="mb-0">
                        <b-form-input id="start_date" name="start_date" v-model="fdata.start_date"
                            v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('start_date')" aria-describedby="start_date-feedback" data-vv-as="Period Start Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker @input="fdata.end_date = fdata.start_date" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.start_date" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="start_date-feedback">
                          {{ veeErrors.first('start_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group id="end_date-group" label="End Date" label-for="end_date" class="required-field mb-0">
                      <b-input-group class="mb-0">
                        <b-form-input id="end_date" name="end_date" v-model="fdata.end_date"
                            v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('end_date')" aria-describedby="end_date-feedback" data-vv-as="Period Start Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker :min="fdata.start_date" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.end_date" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="end_date-feedback">
                          {{ veeErrors.first('end_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>

              </div>

            </div>

            <div class="row" id="assignment">
              <div class="col-12">
                <div class="">
                  <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                               :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
                </div>
              </div>
            </div>

            <div v-if="fdata.shift_id && fdata.start_date && fdata.end_date" align="left" style="float: left; bottom: 0; z-index: 100; " class="position-sticky w-100 bg-white ibox p-3">
              <div>
                <div class="pl-2">
                  <b-form-group label-for="override_off_day">
                    <b-form-checkbox id="override_off_day" name="override_off_day" v-model="fdata.override_off_day" :value="1" :unchecked-value="0" >
                      Override Off Day <b-icon icon="info-circle" v-b-tooltip.hover.top="'Assign the selected shift even if the employee has off days within the selected date range.'"></b-icon>
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group v-if="roster == 1" label-for="override_shift">
                    <b-form-checkbox id="override_shift" name="override_shift" v-model="fdata.override_shift" :value="1" :unchecked-value="0">
                      Override Current Assigned Shift In Date <b-icon icon="info-circle" v-b-tooltip.hover.top="'Replace the employee’s already assigned shift for the selected date range.'"></b-icon>
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group label-for="overtime">
                    <b-form-checkbox id="overtime" name="overtime" v-model="fdata.overtime" :value="1" :unchecked-value="0" v-b-tooltip.hover.top title="Mark this assignment as an overtime shift for the selected employees.">
                      Overtime
                    </b-form-checkbox>
                  </b-form-group>
                </div>

                <b-button type="submit" variant="primary" class="m-2" :disabled="loading">
                  Assign to {{ employee_ids.length }} Employee(s)
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </b-overlay>


  </div>
</template>

<script>

import moment from "moment";

export default {
  props:['roster'],
  data(){
    return {
      loading:false,
      primary_key:'employee_id',
      company_options:[],
      y:2025,
      m:8,
      errors: [],
      checkbox: 0,
      list_key:0,
      is_action: 0,
      custom_list: [],
      depertments: [],
      default_column:[ 'name','employee_code', 'jobposition'],
      appended_column: this.roster == 1 ? [
        { value: "branch", text: "Work Location", type: "text" },
        { value: "department", text: "Department", type: "text" },
        { value: "shift", text: "Today's Shift", type: "text" },
        { value: "off_day", text: "Off Day", type: "text" },
      ] : [
        { value: "branch", text: "Work Location", type: "text" },
        { value: "department", text: "Department", type: "text" },
      ],
      fdata:{
        override_off_day: 0,
        override_shift: 0,
        overtime: 0,
        shift_id: 0,
        start_date: '',
        end_date: '',
        overlap: 0,
      },
      employee_ids: [],
      roster: 0,
      shifts: [],
      branchOptions: [],
    }
  },

  methods:{
    moment,
    avatar(e){
      return `/avatar/${e.company_id}/${e.pic}`;
    },

    listReturn(data) {
      this.employee_ids = data.selected;
    },

    loadShifts() {
      this.loading = true
      axios.get('/leave-attendance/shifts').then((response) => {
        this.shifts = response.data;
        this.loading = false
      }).catch(error => {
        this.serverError(error);
        this.loading = false
      });
    },

    getDepartments: function(){
      axios.get(this.$api_url+'/department/list').then((response) => {
            this.depertments = response.data;
            if(this.roster == null){
              if(this.depertments.length > 0){
                // this.fdata.dept_id = this.depertments[0].id;
                this.getRosters(this.fdata.dept_id);
              }
            }
            else {
              this.getRosters(0);
            }

          });

    },

    getEmployees() {
      this.fdata.start_date = null;
      this.fdata.end_date = null;
      let url = this.$api_url + '/leave-attendance/employees/list';
      let params = {
        general:1,
        fields:'offday,roster,shift'
      };
      this.list_key++;
      this.loading = true;
      axios.get(url, {params: params}).then(response => {
        this.list_key++;
        this.custom_list = response.data.employee_data;
        this.company_options = response.data.options;
        this.loading = false;
      });
    },

    parseYMD: function (dateStr) {
      const [y, m, d] = dateStr.split('-').map(Number);
      return new Date(y, m - 1, d);
    },

    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }

        if (this.employee_ids.length == 0) {
          this.$bvToast.toast("Please select employee(s) first",{
            variant:'danger',
            solid: true,
            title: 'Failed',
          });
          return;
        }

        const st = this.parseYMD(this.fdata.start_date);
        const ed = this.parseYMD(this.fdata.end_date);

        if (st > ed) {
          this.$bvToast.toast(
              "End Date cannot be earlier than Start Date.",
              {
                variant: 'danger',
                solid: true,
                title: 'Failed',
              }
          );
          return;
        }

        this.loading = true;

        const formData = new FormData();
        formData.append('employee_ids', JSON.stringify(this.employee_ids));
        Object.entries(this.fdata).forEach(([key, val]) => {
          formData.append(key, val);
        });

        axios.post(this.$api_url + '/leave-attendance/shift-assign/manual', formData).then(response => {
          if(response.data.errors) {
            this.errors = response.data.errors;
            this.loading = false;
          } else {
            this.list_key++;
            this.employee_ids = [];
            this.getEmployees();
            this.loading = false;
            this.$bvToast.toast(response.data.message,{
              variant: 'success',
              title: 'Success',
              solid: true,
            })
            this.$nextTick().then(_ => {
              this.resetForm();
              this.$validator.reset();
              this.errors.clear();
            });
          }
        }).catch(e => {
          this.loading = false;
          this.serverError(e);
        });
      });
    },

    resetForm(){
      this.fdata = {
        shift_id: 0,
        start_date: '',
        end_date: '',
        overlap: 0,
      };
    },
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster
        }

      }.bind(this));

    },

  },
  created() {
    this.loadShifts();
    this.$validator.reset();
    this.getEmployees();
    this.getCompanyLeaveSettings();
  },
};
</script>
